// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { PDFJS } from 'pdfjs-dist';

// TODO(@DevSDK, @Juyeong-Byeon): 적절한 타입 위치 찾아서 이동하기
interface PDFDocument {
  numPages: number;
}

export async function getPdfTotalPage(pdfArrayBuffer: ArrayBuffer) {
  return ((await PDFJS.getDocument(pdfArrayBuffer)) as PDFDocument).numPages;
}
